// extracted by mini-css-extract-plugin
export var header = "_id-0";